export function RadarChart({ scores }: { scores: Record<string, number> }) {
  const axes = Object.entries(scores).filter(([k]) => k !== "overall");
  const n = axes.length;
  const cx = 100;
  const cy = 100;
  const r = 72;

  function angle(i: number) {
    return -Math.PI / 2 + (i / n) * 2 * Math.PI;
  }

  function point(i: number, scale: number) {
    const a = angle(i);
    return { x: cx + r * scale * Math.cos(a), y: cy + r * scale * Math.sin(a) };
  }

  const gridLevels = [0.2, 0.4, 0.6, 0.8, 1.0];

  const gridPolygons = gridLevels.map((scale) =>
    axes.map((_, i) => `${point(i, scale).x},${point(i, scale).y}`).join(" ")
  );

  const dataPolygon = axes.map(([, value], i) => `${point(i, value / 100).x},${point(i, value / 100).y}`).join(" ");

  return (
    <svg viewBox="0 0 200 200" className="radarChart" aria-label="Score radar chart">
      {gridPolygons.map((pts, i) => (
        <polygon key={i} points={pts} fill="none" stroke="rgba(248,239,224,0.07)" strokeWidth="1" />
      ))}
      {axes.map((_, i) => {
        const p = point(i, 1);
        return <line key={i} x1={cx} y1={cy} x2={p.x} y2={p.y} stroke="rgba(248,239,224,0.05)" strokeWidth="1" />;
      })}
      <polygon points={dataPolygon} className="radarPoly" />
      {axes.map(([key, value], i) => {
        const a = angle(i);
        const lx = cx + (r + 20) * Math.cos(a);
        const ly = cy + (r + 20) * Math.sin(a);
        const anchor = Math.cos(a) < -0.15 ? "end" : Math.cos(a) > 0.15 ? "start" : "middle";
        return (
          <g key={key}>
            <text x={lx} y={ly - 3} textAnchor={anchor} fontSize="6.5" fill="rgba(248,239,224,0.45)" fontFamily="Courier New,monospace" fontWeight="700">
              {key.toUpperCase()}
            </text>
            <text x={lx} y={ly + 8} textAnchor={anchor} fontSize="9" fill="rgba(248,239,224,0.88)" fontWeight="800">
              {value}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
